import React, { useState } from 'react';
interface FeaturedDepartmentsProps {
  onNavigate: (page: 'shop') => void;
}
export function FeaturedDepartments({
  onNavigate
}: FeaturedDepartmentsProps) {
  const departments = [
  // Top row: Dog, Cat, Bird, Fish, Poultry
  {
    title: 'Dog',
    image: 'https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=400&q=80',
    gradient: 'from-brand-blue-600 to-brand-blue-400',
    objectPos: 'object-center',
    emoji: '🐕',
    isMostPopular: true
  }, {
    title: 'Cat',
    image: 'https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba?w=400&q=80',
    gradient: 'from-brand-blue-600 to-brand-blue-400',
    objectPos: 'object-center',
    emoji: '🐈'
  }, {
    title: 'Bird',
    image: 'https://images.unsplash.com/photo-1552728089-57bdde30beb3?w=400&q=80',
    gradient: 'from-brand-blue-600 to-brand-blue-400',
    objectPos: 'object-top',
    emoji: '🦜'
  }, {
    title: 'Fish',
    image: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400&q=80',
    gradient: 'from-brand-blue-600 to-brand-blue-400',
    objectPos: 'object-center',
    emoji: '🐠'
  }, {
    title: 'Poultry',
    image: 'https://images.unsplash.com/photo-1548550023-2bdb3c5beed7?w=400&q=80',
    gradient: 'from-brand-blue-600 to-brand-blue-400',
    objectPos: 'object-center',
    emoji: '🐔'
  },
  // Bottom row: Reptile, Small Animal, Large Animal, Garden, Pool
  {
    title: 'Reptile',
    image: 'https://cdn.magicpatterns.com/uploads/jawCZuBdouzh5njBmsKs38/download_(3).jpg',
    gradient: 'from-brand-blue-600 to-brand-blue-400',
    objectPos: 'object-center',
    emoji: '🦎'
  }, {
    title: 'Small Animal',
    image: 'https://images.unsplash.com/photo-1585110396000-c9ffd4e4b308?w=400&q=80',
    gradient: 'from-brand-blue-600 to-brand-blue-400',
    objectPos: 'object-center',
    emoji: '🐰'
  }, {
    title: 'Large Animal',
    image: 'https://images.unsplash.com/photo-1553284965-83fd3e82fa5a?w=400&q=80',
    gradient: 'from-brand-blue-600 to-brand-blue-400',
    objectPos: 'object-center',
    emoji: '🐴'
  }, {
    title: 'Garden',
    image: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=400&q=80',
    gradient: 'from-brand-blue-600 to-brand-blue-400',
    objectPos: 'object-center',
    emoji: '🌿'
  }, {
    title: 'Pool',
    image: 'https://images.unsplash.com/photo-1576013551627-0cc20b96c2a7?w=400&q=80',
    gradient: 'from-brand-blue-600 to-brand-blue-400',
    objectPos: 'object-center',
    emoji: '🏊'
  }];
  return <section className="bg-white py-4 md:py-5" data-id="element-111">
      <div className="container-wide" data-id="element-112">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4" data-id="element-113">
          {departments.map((dept, index) => <DepartmentTile key={index} dept={dept} onNavigate={onNavigate} data-id="element-114" />)}
        </div>
      </div>
    </section>;
}
interface DepartmentTileProps {
  dept: {
    title: string;
    image: string;
    gradient: string;
    objectPos: string;
    emoji: string;
    isMostPopular?: boolean;
  };
  onNavigate: (page: 'shop') => void;
}
function DepartmentTile({
  dept,
  onNavigate
}: DepartmentTileProps) {
  const [imgFailed, setImgFailed] = useState(false);
  return <div className={`bg-gradient-to-br ${dept.gradient} rounded-2xl overflow-hidden cursor-pointer group relative shadow-sm hover:shadow-md transition-all duration-300 hover:-translate-y-0.5 active:scale-[0.98]`} onClick={() => onNavigate('shop')} style={{
    height: 'clamp(90px, 14vw, 120px)'
  }} data-id="element-115">
      {dept.isMostPopular && <div className="absolute top-2 left-2 z-20 bg-brand-green text-[#002faa] text-[10px] font-bold px-2 py-0.5 rounded-full shadow-sm" data-id="element-116">
          Most Popular
        </div>}

      <div className="absolute left-4 md:left-5 top-1/2 -translate-y-1/2 z-10" data-id="element-117">
        <h3 className="font-heading font-bold text-base md:text-xl text-white leading-tight" style={{
        textShadow: '0 1px 4px rgba(0,0,0,0.25)'
      }} data-id="element-118">
          {dept.title}
        </h3>
      </div>

      <div className="absolute right-0 top-0 bottom-0 w-[58%] overflow-hidden" data-id="element-119">
        {!imgFailed ? <img src={dept.image} alt={dept.title} onError={() => setImgFailed(true)} loading="eager" className={`w-full h-full object-cover ${dept.objectPos} transform group-hover:scale-110 transition-transform duration-500`} style={{
        maskImage: 'linear-gradient(to right, transparent 0%, black 30%)',
        WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 30%)'
      }} data-id="element-120" /> : <div className="w-full h-full flex items-center justify-end pr-4 md:pr-6" style={{
        maskImage: 'linear-gradient(to right, transparent 0%, black 30%)',
        WebkitMaskImage: 'linear-gradient(to right, transparent 0%, black 30%)'
      }} data-id="element-121">
            <span className="text-5xl md:text-6xl opacity-80 drop-shadow-lg select-none" data-id="element-122">
              {dept.emoji}
            </span>
          </div>}
      </div>

      <div className="absolute inset-0 bg-gradient-to-tr from-white/0 via-white/10 to-white/0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-123"></div>
    </div>;
}